function handleComparisonTable(): void {
    const tables = document.querySelectorAll<HTMLTableElement>('.jbf-table__table');
    const breakpoint = 1024;

    if (tables) {
        tables.forEach((table) => {
            const mobileViewId = table.getAttribute('data-mobileview');
            const mobileViewDiv = document.getElementById(mobileViewId || '');

            if (mobileViewDiv) {
                const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);
                if (mediaQuery.matches) {
                    table.style.display = 'none';
                    mobileViewDiv.style.display = 'block';
                } else {
                    table.style.display = 'table';
                    mobileViewDiv.style.display = 'none';
                }
            }
        });
    }
}

export default function comparisonTables(): void {
    handleComparisonTable();
    window.addEventListener('resize', handleComparisonTable);
}
